import { StorageService } from '../flowOrchestrationService/StorageService'

class RedirectService {
	#storageService = new StorageService()
	#applicantId: string | null = null

	public getRedirectUrl = () => {
		return this.#storageService.get(this.#getRedirectUrlKey(this.#applicantId))
	}

	public setApplicantId = (applicantId: string) => {
		this.#applicantId = applicantId
	}

	public setRedirectUrl = ({
		applicantId,
		redirectUrl,
		consumerId,
	}: {
		applicantId: string | null
		redirectUrl: string | null
		consumerId: string | null
	}) => {
		this.#applicantId = applicantId
		this.#storageService.set(
			this.#getRedirectUrlKey(this.#applicantId),
			redirectUrl != null && consumerId != null
				? this.#decorateRedirectUrl(redirectUrl, consumerId)
				: null,
		)
	}

	#decorateRedirectUrl = (redirectUrl: string, consumerId: string) => {
		const querySegments = redirectUrl.split('/')
		const hasQueryParameters =
			querySegments[querySegments.length - 1]?.includes('?')
		const queryStringParameterSubstring = hasQueryParameters ? '&' : '?'

		const decoratedRedirectUrl =
			redirectUrl + `${queryStringParameterSubstring}userId=${consumerId}`

		return decoratedRedirectUrl
	}

	#getRedirectUrlKey = (applicantId: string | null) =>
		`${applicantId}::RedirectUrl`
}

export const redirectService = new RedirectService()
